export const returnObject = (keyArray, valueArray) => {
  let obj = {}
  let array = [...Array(keyArray.length).keys()]

  array.forEach((val) => {
    obj[keyArray[val]] = valueArray[val]
  })

  return obj
}

export const textArray = ['CATEGORY', 'SUBCATEGORY', 'PRODUCT', 'EMPLOYEE', 'SALES', 'REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'AREA', 'STORE', 'TARGET', 'SCHEME', 'SFTP']
export const routeArray = textArray.map((val) => `OVERVIEW_${val}_STATUS`)

export const getRoutes = () => {
  const returnString = (array, route, detail, detailRoute) => {
    return array.map((val) =>
      detailRoute ? `/upload-status/${val.toLowerCase()}/:statusId` : detail ? `${val}_STATUS` : route ? `/upload-status/overview/${val.toLowerCase()}` : `OVERVIEW_${val}_STATUS`
    )
  }

  //  const returnRouteObj = (array, route, detail, detailRoute) => {

  // }

  //  let tempObj = {}

  const keyArrayOverview = returnString(textArray)
  const valueArrayOverview = returnString(textArray, true)
  const keyArrayDetail = returnString(textArray, false, true)
  const valueArrayDetail = returnString(textArray, false, false, true)

  return { overviewRoute: returnObject(keyArrayOverview, valueArrayOverview), detailRoute: returnObject(keyArrayDetail, valueArrayDetail) }
}

export const booleanOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
]

export const selectDropdown = { fieldName: 'name', fieldValue: '_id' }
export const isAllElementsExist = (arr, target) => {
  let tempArray = []
  target.forEach((v) => {
    if (arr.includes(v)) {
      tempArray.push(v)
    }
  })
  //console.log('tempArray : ', tempArray)
  return tempArray
}

export const convertKb = (bytes) => {
  var i = Math.floor(Math.log(bytes) / Math.log(1024)),
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  console.log((bytes / Math.pow(1024, i)).toFixed(2) * 1)
  return (bytes / Math.pow(1024, i)).toFixed(2) * 1
}
